import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { setRouteLoading } from "../../utilities/routeLoadingManager";

/**
 * Marks route transition loading on every navigation (before lazy chunk paint).
 * Mount outside Suspense. Kept for any consumers of routeLoadingManager;
 * the visible loader UI lives in GenericHeader or PageLoader — never both.
 */
export function RouteTransitionStart() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    setRouteLoading(true);
  }, [pathname, search]);

  return null;
}

/**
 * Clears route transition loading once the matched route has mounted.
 * Mount inside Suspense.
 */
export function RouteTransitionReady() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    const id = requestAnimationFrame(() => {
      setRouteLoading(false);
    });
    return () => cancelAnimationFrame(id);
  }, [pathname, search]);

  return null;
}

/**
 * @deprecated Layout-level header loader removed to prevent double loaders
 * with GenericHeader / PageLoader. Kept as no-op for import compatibility.
 */
export function LayoutHeaderApiLoader() {
  return null;
}
